#import "./AliyahDetails.graphql"
#import "./ParashahDetails.graphql"
fragment aliyahDetailsWithParashah on AliyahType {
  ...aliyahDetails
  parashah {
    ...parashahDetails
  }
}
